import React, { useEffect } from "react";
import { useParams } from "react-router-dom";

export function Calculator() {
  const { calculator_id } = useParams();

  const el = document.querySelector<HTMLElement>(`#ic_iframe_${calculator_id}`);

  useEffect(() => {
    if (el) {
      el.style.width = "calc(100% + 16px)";
      el.style.margin = "0 -8px";
    }
  }, [el]);

  useEffect(() => {
    const script = document.createElement("script");

    script.src = "https://embed.interactivecalculator.com/embed.js";
    script.async = true;
    script.type = "text/javascript";
    script.dataset.type = "iframe";
    script.dataset.calculatorId = calculator_id;

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <div className="mt-6">
      <h4 className="text-primary font-semibold mb-2 text-lg">
        Simulador de Cálculo
      </h4>
      <div
        className="bg-orange-100 border-l-4 border-orange-500 text-orange-700 p-2 rounded-sm mb-4"
        role="alert"
      >
        <p>
          O simulador de cálculo reflete apenas uma estimativa de ganho com base
          nas variáveis adicionadas. O valor efetivo a ser recuperado dependerá
          de confirmação do indébito através de uma análise contábil.
        </p>
      </div>
      <span data-calculator-id={calculator_id}></span>
    </div>
  );
}
